/** @jsxImportSource @emotion/react */
"use client";

import { Close as DialogClose } from "@radix-ui/react-dialog";
import { Button as ToolbarButton } from "@radix-ui/react-toolbar";
import type { MouseEventHandler } from "react";

import { colors } from "../../../../../../global/emotion";
import { IconButton } from "../../../../../components/_base/_core/IconButton/IconButton.emotion";
import { CloseIcon } from "../../../../../components/_base/icons/Icon/NavigationIcons";
import { emotionDynamics } from "../../../../../lib/emotionDynamics";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";

export type CloseButtonProps = HallowElementProps<"button"> & {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const CloseButton = ({ onClick, className = "" }: CloseButtonProps) => (
  <ToolbarButton asChild>
    <DialogClose asChild>
      <IconButton
        icon={<CloseIcon fill={colors.white} />}
        variant={"transparentWhite"}
        onClick={onClick}
        css={emotionDynamics.hideDesktopViewport("flex")}
        className={className}
        tabIndex={0}
      />
    </DialogClose>
  </ToolbarButton>
);
